module.exports = __webpack_public_path__ + "static/media/process-bottom.35fa87fe.png";